import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import ScrollToTop from './Components/ScrollToTop';


ReactDOM.render(
  <React.StrictMode>
    <App />
    <ScrollToTop />
  </React.StrictMode>,
  document.getElementById('root')
);

